// import React from 'react';
//
// const TRAFFIC_OPTIONS = [
//     { label: 'Классика', value: 'classic' },
//     { label: 'Трансгран', value: 'transgran' },
//     { label: 'НСПК', value: 'nspk' },
//     { label: 'Директ-Банк', value: 'direct-bank' }
// ];
//
// const StakeRangeEditor = ({ merchantData, setMerchantData, setCreateError }) => {
//     const ranges = merchantData.stakeRanges || [];
//
//     const updateRanges = (newRanges) => {
//         setMerchantData(prev => ({
//             ...prev,
//             stakeRanges: newRanges
//         }));
//     };
//
//     const handleInputChange = (index, field, value) => {
//
//         setCreateError({show: false})
//         const updated = [...ranges];
//         updated[index][field] = value;
//         updateRanges(updated);
//     };
//
//     const handleAddRange = () => {
//         const newRanges = [
//             ...ranges,
//             { min: '', max: '', value: '', trafficType: '' }
//         ];
//         updateRanges(newRanges);
//     };
//
//     const handleRemoveRange = (index) => {
//         const updated = ranges.filter((_, i) => i !== index);
//         updateRanges(updated);
//     };
//
//     const canAdd = ranges.every(r =>
//         r.min !== '' && r.max !== '' && r.value !== '' && r.trafficType !== ''
//     );
//
//     return (
//         <div>
//             {ranges.length === 0 ? (
//                 <button onClick={handleAddRange}>Добавить диапазон</button>
//             ) : (
//                 <>
//                     {ranges.map((range, i) => (
//                         <div key={i} style={{ marginBottom: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//                             <input
//                                 type="number"
//                                 placeholder="От"
//                                 value={range.min}
//                                 onChange={e => handleInputChange(i, 'min', e.target.value)}
//                             />
//                             <input
//                                 type="number"
//                                 placeholder="До"
//                                 value={range.max}
//                                 onChange={e => handleInputChange(i, 'max', e.target.value)}
//                             />
//                             <input
//                                 type="number"
//                                 placeholder="Ставка"
//                                 value={range.value}
//                                 onChange={e => handleInputChange(i, 'value', e.target.value)}
//                             />
//                             <select
//                                 value={range.trafficType}
//                                 onChange={e => handleInputChange(i, 'trafficType', e.target.value)}
//                             >
//                                 <option value="">Тип трафика</option>
//                                 {TRAFFIC_OPTIONS.map(opt => (
//                                     <option key={opt.value} value={opt.value}>
//                                         {opt.label}
//                                     </option>
//                                 ))}
//                             </select>
//                             <button onClick={() => handleRemoveRange(i)}>Удалить</button>
//                         </div>
//                     ))}
//                     <button onClick={handleAddRange} disabled={!canAdd}>Добавить диапазон</button>
//                 </>
//             )}
//         </div>
//     );
// };
//
// export default StakeRangeEditor;



import React, { useState, useEffect } from 'react';

const TRAFFIC_OPTIONS = [
    { label: 'Классика', value: 'classic' },
    { label: 'Трансгран', value: 'transgran' },
    { label: 'НСПК', value: 'nspk' },
    { label: 'Директ-Банк', value: 'direct-bank' }
];

const StakeRangeEditor = ({ merchantData, setMerchantData, setCreateError }) => {
    const ranges = merchantData.stakeRanges || [];
    const [rangeErrors, setRangeErrors] = useState([]);

    useEffect(() => {
        // Проверка всех диапазонов на валидность
        const errors = ranges.map(r =>
            r.min === '' || r.max === '' || isNaN(r.min) || isNaN(r.max)
                ? false
                : parseFloat(r.min) >= parseFloat(r.max)
        );
        setRangeErrors(errors);
    }, [ranges]);

    const updateRanges = (newRanges) => {
        setMerchantData(prev => ({
            ...prev,
            stakeRanges: newRanges
        }));
    };

    const handleInputChange = (index, field, value) => {
        setCreateError({ show: false });

        const updated = [...ranges];
        updated[index][field] = value;
        updateRanges(updated);
    };

    const handleAddRange = () => {
        const newRanges = [...ranges, { min: '', max: '', value: '', trafficType: '' }];
        updateRanges(newRanges);
    };

    const handleRemoveRange = (index) => {
        const updated = ranges.filter((_, i) => i !== index);
        updateRanges(updated);
    };

    const canAdd = ranges.every(r =>
        r.min !== '' && r.max !== '' && r.value !== '' && r.trafficType !== '' &&
        parseFloat(r.min) < parseFloat(r.max)
    );

    return (
        <div>
            <h3>Диапазоны ставок</h3>
            {ranges?.length === 0 ? (
                <button onClick={handleAddRange}>Добавить диапазон</button>
            ) : (
                <>
                    {ranges.map((range, i) => {
                        const hasError = rangeErrors[i];
                        return (
                            <div
                                key={i}
                                style={{
                                    marginBottom: '10px',

                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap',
                                    border: hasError ? '1px solid red' : 'none',
                                    padding: '5px',
                                    borderRadius: '6px',

                                    justifyContent: "center"
                                }}
                            >
                                <input
                                    type="number"
                                    placeholder="От"
                                    value={range.min}
                                    onChange={e => handleInputChange(i, 'min', e.target.value)}
                                    style={hasError ? { borderColor: 'red' } : {}}
                                />
                                <input
                                    type="number"
                                    placeholder="До"
                                    value={range.max}
                                    onChange={e => handleInputChange(i, 'max', e.target.value)}
                                    style={hasError ? { borderColor: 'red' } : {}}
                                />
                                <input
                                    type="number"
                                    placeholder="Ставка"
                                    value={range.value}
                                    onChange={e => handleInputChange(i, 'value', e.target.value)}
                                />
                                <select
                                    value={range.trafficType}
                                    onChange={e => handleInputChange(i, 'trafficType', e.target.value)}
                                >
                                    <option value="">Тип трафика</option>
                                    {TRAFFIC_OPTIONS.map(opt => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                                <button onClick={() => handleRemoveRange(i)}>Удалить</button>
                                {hasError && (
                                    <div style={{ color: 'red', fontSize: '12px', width: '30%', margin: "auto", display: 'flex', justifyContent: 'center' }}>
                                        Недопустимый диапазон: "До" должно быть больше "От"
                                    </div>
                                )}
                            </div>
                        );
                    })}
                    <button onClick={handleAddRange} disabled={!canAdd}>Добавить диапазон</button>
                </>
            )}
        </div>
    );
};

export default StakeRangeEditor;
